
export let messageTypes = [{ value: 1, name: "existingCustomer" },
{ value: 2, name: "newCustomer" },
{ value: 3, name: "locationAndContact" },
{ value: 4, name: "availability" }]